// Este codigo fue generado por Github Copilot Chat
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ButtonComponent } from '../shared/molecules/button/button.component';
import {
  ButtonTypeEnum,
  ButtonSizeEnum
} from '../shared/molecules/button/buttonTypesEnum';
import { InputTextComponent } from '../shared/molecules/input-text/input-text.component';
import { SelectComponent } from '../shared/molecules/select/select.component';
import { CardComponent } from '../shared/molecules/card/card.component';
import { TableComponent } from '../shared/molecules/app-table/app-table.component';
import { ModalComponent } from '../shared/molecules/modal/modal.component';
import { SelectOption } from '../shared/molecules/select/options.type';
import { TableActionType } from '../shared/molecules/app-table/tableActionTypes';
import { InputCheckComponent } from '../shared/molecules/input-check/input-check.component';
import { AppInputDateComponent } from '../shared/molecules/input-date/input-date.component';
import { AppInputTimeComponent } from '../shared/molecules/input-time/input-time.component';
import { InputTextAreaComponent } from '../shared/molecules/input-text-area/input-text-area.component';
import { AppInputNumberComponent } from '../shared/molecules/input-number/input-number.component';
import { InputSearchComponent } from '../shared/molecules/input-search/input-search.component';
import { InputFileComponent } from '../shared/molecules/input-file/input-file.component';
import { AppInputDropdownComponent } from '../shared/molecules/input-dropdown/input-dropdown.component';
import { AppLoaderComponent } from '../shared/molecules/loader/loader.component';
import { ToastComponent } from '../shared/molecules/toast/toast.component';
import { TabComponent } from '../shared/molecules/tab/tab.component';
import { PaginatorComponent } from '../shared/molecules/paginator/paginator.component';
import { AvatarComponent } from '../shared/molecules/avatar/avatar.component';
import { AppDatePickerComponent } from '../shared/molecules/app-date-picker/app-date-picker.component';
import { CollapsibleComponent } from '../shared/molecules/collapsible/collapsible.component';
import { Tab } from '../shared/molecules/tab/tabType';
import { ToastService } from '../shared/molecules/toast/service/toast.service';
import { ToastTypeEnum } from '../shared/molecules/toast/toast-type-enum';
import { LoaderType } from '@helpers/html/loader-type';
import { AppInputOption } from '@helpers/input/input.option';

interface DemoUser extends Record<string, unknown> {
  id: string;
  name: string;
  email: string;
  role: string;
  status: string;
}

@Component({
  selector: 'app-component-showcase',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonComponent,
    InputTextComponent,
    SelectComponent,
    CardComponent,
    TableComponent,
    ModalComponent,
    InputCheckComponent,
    AppInputDateComponent,
    AppInputTimeComponent,
    InputTextAreaComponent,
    AppInputNumberComponent,
    InputSearchComponent,
    InputFileComponent,
    AppInputDropdownComponent,
    AppLoaderComponent,
    ToastComponent,
    TabComponent,
    PaginatorComponent,
    AvatarComponent,
    AppDatePickerComponent,
    CollapsibleComponent
  ],
  template: `
    <div class="showcase-container">
      <h1>🎨 Showcase de Componentes Shared</h1>

      <!-- Sección Botones -->
      <app-card>
        <h2>🔘 Botones</h2>
        <div class="button-grid">
          <app-button
            label="Primary"
            [type]="ButtonTypeEnum.PRIMARY"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>

          <app-button
            label="Secondary"
            [type]="ButtonTypeEnum.SECONDARY"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>

          <app-button
            label="Primary Outline"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>

          <app-button
            label="Danger"
            [type]="ButtonTypeEnum.DANGER"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>

          <app-button
            label="Large"
            [type]="ButtonTypeEnum.PRIMARY"
            [size]="ButtonSizeEnum.LG"
          >
          </app-button>

          <app-button
            label="Small"
            [type]="ButtonTypeEnum.PRIMARY"
            [size]="ButtonSizeEnum.SM"
          >
          </app-button>

          <app-button
            label="With Icon"
            [type]="ButtonTypeEnum.PRIMARY"
            [leftIcon]="'pi pi-save'"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>

          <app-button
            label="Disabled"
            [type]="ButtonTypeEnum.DISABLED"
            [disabled]="true"
            [size]="ButtonSizeEnum.MD"
          >
          </app-button>
        </div>
      </app-card>

      <!-- Sección Formularios -->
      <app-card>
        <h2>📝 Componentes de Formulario</h2>
        <h4>Inputs de Texto</h4>
        <form [formGroup]="demoForm" class="form-grid">
          <app-input-text
            [formControl]="nameControl"
            label="Nombre Completo"
            placeholder="Ingrese su nombre"
          >
          </app-input-text>

          <app-input-text
            [formControl]="emailControl"
            label="Email"
            placeholder="ejemplo@email.com"
            type="email"
          >
          </app-input-text>

          <app-input-search
            [formControl]="searchControl"
            label="Búsqueda"
            placeholder="Buscar..."
            (searchChange)="onSearchChange($event)"
          >
          </app-input-search>

          <app-input-text-area
            [formControl]="descriptionControl"
            label="Descripción"
            placeholder="Ingrese descripción"
            [rows]="4"
          >
          </app-input-text-area>
        </form>

        <h4>Selects y Dropdowns</h4>
        <form [formGroup]="demoForm" class="form-grid">
          <app-select
            [formControl]="roleControl"
            [options]="roleOptions"
            label="Rol"
            placeholder="Seleccione un rol"
          >
          </app-select>

          <app-select
            [formControl]="countryControl"
            [options]="countryOptions"
            label="País"
            placeholder="Seleccione país"
          >
          </app-select>
        </form>

        <h4>Inputs Numéricos y Fechas</h4>
        <form [formGroup]="demoForm" class="form-grid">
          <app-input-number
            [formControl]="quantityControl"
            label="Cantidad"
            id="quantity-input"
            [incrementor]="true"
            [decrementor]="true"
          >
          </app-input-number>

          <app-input-date
            [formControl]="dateControl"
            label="Fecha"
            id="date-input"
            placeholder="Seleccione fecha"
          >
          </app-input-date>

          <app-input-time
            [formControl]="timeControl"
            label="Hora"
            id="time-input"
            placeholder="Seleccione hora"
          >
          </app-input-time>

          <app-date-picker
            [formControl]="datePickerControl"
            label="Date Picker"
            placeholder="Seleccione fecha"
          >
          </app-date-picker>
        </form>

        <h4>Checkbox</h4>
        <form [formGroup]="demoForm" class="form-grid">
          <app-input-check
            [formControl]="acceptControl"
            label="Acepto términos y condiciones"
          >
          </app-input-check>

          <app-input-check
            [formControl]="newsletterControl"
            label="Suscribirse al newsletter"
          >
          </app-input-check>
        </form>

        <h4>Otros Inputs</h4>
        <form [formGroup]="demoForm" class="form-grid">
          <app-input-file
            [formControl]="fileControl"
            label="Subir Archivo"
            accept=".pdf,.doc,.docx"
          >
          </app-input-file>

          <app-input-dropdown
            [formControl]="dropdownControl"
            [items]="dropdownOptions"
            label="Dropdown"
            id="dropdown-input"
          >
          </app-input-dropdown>
        </form>

        <div class="form-actions">
          <app-button
            label="Cancelar"
            [type]="ButtonTypeEnum.SECONDARY"
            (handleClick)="onCancel()"
          >
          </app-button>

          <app-button
            label="Guardar"
            [type]="ButtonTypeEnum.PRIMARY"
            [disabled]="demoForm.invalid"
            (handleClick)="onSave()"
          >
          </app-button>
        </div>
      </app-card>

      <!-- Sección Tabla -->
      <app-card>
        <h2>🗃️ Tabla de Datos</h2>
        <app-table
          [items]="tableData"
          [visibleColumns]="tableColumns"
          [tableName]="'Usuarios del Sistema'"
          [tableActions]="tableActions"
          (filterEmitter)="onTableFilter($event)"
        >
        </app-table>
      </app-card>

      <!-- Sección Avatar -->
      <app-card>
        <h2>👤 Avatar</h2>
        <div class="avatar-grid">
          <app-avatar
            [name]="'Juan Pérez'"
            [border]="true"
            (clicked)="onAvatarClick($event)"
          >
          </app-avatar>

          <app-avatar
            [name]="'María García'"
            [icon]="'pi pi-user'"
            [border]="true"
          >
          </app-avatar>

          <app-avatar [label]="'Admin'" [border]="false"> </app-avatar>
        </div>
      </app-card>

      <!-- Sección Tabs -->
      <app-card>
        <h2>📑 Tabs</h2>
        <app-tab [tabList]="tabList" (clickEmitter)="onTabClick($event)">
        </app-tab>
        <div class="tab-content">
          <p>Contenido del tab activo: {{ activeTabContent }}</p>
        </div>
      </app-card>

      <!-- Sección Loader -->
      <app-card>
        <h2>⏳ Loader</h2>
        <app-loader [type]="LoaderType.Skeleton" [count]="3"></app-loader>
      </app-card>

      <!-- Sección Paginator -->
      <app-card>
        <h2>📄 Paginador</h2>
        <app-paginator
          [totalRegister]="100"
          (getData)="onPaginationChange($event)"
        >
        </app-paginator>
      </app-card>

      <!-- Sección Toast -->
      <app-card>
        <h2>🔔 Toast</h2>
        <div class="button-grid">
          <app-button
            label="Toast Success"
            [type]="ButtonTypeEnum.PRIMARY"
            (handleClick)="showToast('success')"
          >
          </app-button>

          <app-button
            label="Toast Error"
            [type]="ButtonTypeEnum.DANGER"
            (handleClick)="showToast('error')"
          >
          </app-button>

          <app-button
            label="Toast Info"
            [type]="ButtonTypeEnum.SECONDARY"
            (handleClick)="showToast('info')"
          >
          </app-button>

          <app-button
            label="Toast Warning"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            (handleClick)="showToast('warning')"
          >
          </app-button>
        </div>
      </app-card>

      <!-- Sección Collapsible -->
      <app-card>
        <h2>📂 Collapsible</h2>

        <h4>Ejemplo con Checkboxes</h4>
        <app-collapsible title="Prioridad" [isExpanded]="true">
          <app-input-check
            [formControl]="acceptControl"
            label="Estándar"
          ></app-input-check>
          <app-input-check
            [formControl]="newsletterControl"
            label="Administrativa"
          ></app-input-check>
          <app-input-check
            [formControl]="acceptControl"
            label="Institución"
          ></app-input-check>
          <app-input-check
            [formControl]="newsletterControl"
            label="Clínica"
          ></app-input-check>
          <app-input-check
            [formControl]="acceptControl"
            label="Todas"
          ></app-input-check>
        </app-collapsible>

        <app-collapsible title="Regional" [isExpanded]="false">
          <app-input-check
            [formControl]="acceptControl"
            label="Bogotá"
          ></app-input-check>
          <app-input-check
            [formControl]="newsletterControl"
            label="Medellín"
          ></app-input-check>
          <app-input-check
            [formControl]="acceptControl"
            label="Cali"
          ></app-input-check>
        </app-collapsible>

        <app-collapsible title="Tipo de examen" [isExpanded]="false">
          <app-input-check
            [formControl]="acceptControl"
            label="Laboratorio"
          ></app-input-check>
          <app-input-check
            [formControl]="newsletterControl"
            label="Imagenología"
          ></app-input-check>
        </app-collapsible>

        <app-collapsible title="Fecha" [isExpanded]="false">
          <p style="padding: 1rem; color: #666;">
            Contenido personalizado aquí...
          </p>
        </app-collapsible>
      </app-card>

      <!-- Sección Modal -->
      <app-card>
        <h2>🪟 Modal</h2>
        <div class="text-center">
          <app-button
            label="Abrir Modal"
            [type]="ButtonTypeEnum.PRIMARY"
            (handleClick)="openModal()"
          >
          </app-button>
        </div>
      </app-card>

      <!-- Modal Demo -->
      <app-modal
        [title]="'Modal de Demostración'"
        [isOpen]="showModal"
        [width]="50"
        [height]="100"
        (closeModal)="closeModal()"
      >
        <div class="modal-content">
          <p>Este es un ejemplo de modal funcionando.</p>
          <p>Puedes agregar cualquier contenido aquí.</p>

          <div class="modal-actions">
            <app-button
              label="Cancelar"
              [type]="ButtonTypeEnum.SECONDARY"
              (handleClick)="closeModal()"
            >
            </app-button>

            <app-button
              label="Confirmar"
              [type]="ButtonTypeEnum.PRIMARY"
              (handleClick)="confirmModal()"
            >
            </app-button>
          </div>
        </div>
      </app-modal>

      <!-- Toast Component -->
      <app-toast></app-toast>
    </div>
  `,
  styleUrls: ['./component-showcase.component.scss']
})
export class ComponentShowcaseComponent implements OnInit {
  // Enums para template
  ButtonTypeEnum = ButtonTypeEnum;
  ButtonSizeEnum = ButtonSizeEnum;
  LoaderType = LoaderType;

  // Form
  demoForm: FormGroup;
  nameControl: FormControl;
  emailControl: FormControl;
  roleControl: FormControl;
  countryControl: FormControl;
  searchControl: FormControl;
  descriptionControl: FormControl;
  quantityControl: FormControl;
  dateControl: FormControl;
  timeControl: FormControl;
  datePickerControl: FormControl;
  acceptControl: FormControl;
  newsletterControl: FormControl;
  fileControl: FormControl;
  dropdownControl: FormControl;

  // Options para selects
  roleOptions: SelectOption<string>[] = [
    { value: 'admin', label: 'Administrador' },
    { value: 'user', label: 'Usuario' },
    { value: 'moderator', label: 'Moderador' },
    { value: 'guest', label: 'Invitado' }
  ];

  countryOptions: SelectOption<string>[] = [
    { value: 'co', label: 'Colombia' },
    { value: 'mx', label: 'México' },
    { value: 'ar', label: 'Argentina' },
    { value: 'pe', label: 'Perú' },
    { value: 'cl', label: 'Chile' }
  ];

  dropdownOptions: AppInputOption[] = [
    { id: '1', description: 'Opción 1' },
    { id: '2', description: 'Opción 2' },
    { id: '3', description: 'Opción 3' },
    { id: '4', description: 'Opción 4' }
  ];

  // Tabla
  tableData: DemoUser[] = [
    {
      id: '1',
      name: 'Juan Pérez',
      email: 'juan@example.com',
      role: 'Admin',
      status: 'Activo'
    },
    {
      id: '2',
      name: 'María García',
      email: 'maria@example.com',
      role: 'Usuario',
      status: 'Activo'
    },
    {
      id: '3',
      name: 'Carlos López',
      email: 'carlos@example.com',
      role: 'Moderador',
      status: 'Inactivo'
    },
    {
      id: '4',
      name: 'Ana Martínez',
      email: 'ana@example.com',
      role: 'Usuario',
      status: 'Activo'
    }
  ];

  tableColumns = [
    { key: 'name', label: 'Nombre', searchable: true },
    { key: 'email', label: 'Email', searchable: true },
    { key: 'role', label: 'Rol', searchable: false },
    { key: 'status', label: 'Estado', searchable: false }
  ];

  tableActions: TableActionType[] = [
    { icon: 'pi pi-pencil' },
    { icon: 'pi pi-trash' }
  ];

  // Estados
  showModal = false;

  // Tabs
  tabList: Tab[] = [
    { label: 'Tab 1', isActive: true },
    { label: 'Tab 2', isActive: false },
    { label: 'Tab 3', isActive: false }
  ];
  activeTabContent = 'Tab 1';

  constructor(private readonly toastService: ToastService) {
    // Inicializar controles individuales
    this.nameControl = new FormControl('', [
      (control) => Validators.required(control),
      (control) => Validators.minLength(2)(control)
    ]);
    this.emailControl = new FormControl('', [
      (control) => Validators.required(control),
      (control) => Validators.email(control)
    ]);
    this.roleControl = new FormControl('', [
      (control) => Validators.required(control)
    ]);
    this.countryControl = new FormControl('', [
      (control) => Validators.required(control)
    ]);

    // Nuevos controles
    this.searchControl = new FormControl('');
    this.descriptionControl = new FormControl('', [
      (control) => Validators.minLength(10)(control)
    ]);
    this.quantityControl = new FormControl(0, [
      (control) => Validators.min(0)(control)
    ]);
    this.dateControl = new FormControl('');
    this.timeControl = new FormControl('');
    this.datePickerControl = new FormControl('');
    this.acceptControl = new FormControl(false);
    this.newsletterControl = new FormControl(false);
    this.fileControl = new FormControl(null);
    this.dropdownControl = new FormControl('');

    // Crear formulario con controles
    this.demoForm = new FormGroup({
      name: this.nameControl,
      email: this.emailControl,
      role: this.roleControl,
      country: this.countryControl,
      search: this.searchControl,
      description: this.descriptionControl,
      quantity: this.quantityControl,
      date: this.dateControl,
      time: this.timeControl,
      datePicker: this.datePickerControl,
      accept: this.acceptControl,
      newsletter: this.newsletterControl,
      file: this.fileControl,
      dropdown: this.dropdownControl
    });
  }

  ngOnInit(): void {
    console.log('Component showcase initialized');
  }

  // Métodos de formulario
  onSave(): void {
    if (this.demoForm.valid) {
      console.log('Form data:', this.demoForm.value);
      alert('Formulario guardado exitosamente!');
    }
  }

  onCancel(): void {
    this.demoForm.reset();
    console.log('Form cancelled');
  }

  // Métodos de tabla
  onTableFilter(event: unknown): void {
    console.log('Table filter:', event);
  }

  // Métodos para nuevos componentes
  onSearchChange(searchTerm: string): void {
    console.log('Search term:', searchTerm);
  }

  onAvatarClick(uuid: string): void {
    console.log('Avatar clicked:', uuid);
  }

  onTabClick(position: number): void {
    this.activeTabContent = `Tab ${position + 1}`;
    console.log('Tab clicked:', position);
  }

  onPaginationChange(event: unknown): void {
    console.log('Pagination changed:', event);
  }

  showToast(type: string): void {
    const messages = {
      success: { title: 'Éxito', message: 'Operación completada exitosamente' },
      error: { title: 'Error', message: 'Ocurrió un error en la operación' },
      info: { title: 'Información', message: 'Esto es un mensaje informativo' },
      warning: { title: 'Advertencia', message: 'Por favor tenga precaución' }
    };

    const toastType = type as keyof typeof messages;
    const config = messages[toastType];

    this.toastService.setToast({
      title: config.title,
      message: config.message,
      type: type.toUpperCase() as ToastTypeEnum
    });
  }

  // Métodos de modal
  openModal(): void {
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

  confirmModal(): void {
    alert('Modal confirmado!');
    this.closeModal();
  }
}
// Este codigo fue generado por Github Copilot Chat
